import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, NgZone, signal } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { firstValueFrom, Subscription } from 'rxjs';
import { ProjectVersion } from 'src/app/constants/project-version-constans';
import { PreviewOrderByEnums } from 'src/app/enum/preview-order-by-enums';
import { PreinvoicingDetailPrintModel } from 'src/app/models/print/invoicing/preinvoicing-detail-print.model';
import { PreinvoicingPrintModel } from 'src/app/models/print/invoicing/preinvoicing-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FormatDetailService } from 'src/app/services/formats/format-detail.service';
import { PrintPageSizeService } from 'src/app/services/global-services/print-page-size.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { GeneralParameterEnums } from './../../../../enum/general-parameter-enums';
import { ItemFilterModel } from './../../../../models/filters/item-filter.model';
import { FormatDetailModel } from './../../../../models/formats/format-detail.model';
import { FormatModel } from './../../../../models/formats/format.model';
import { MovementDetailModel } from './../../../../models/invoicing/movement-detail.model';
import { MovementService } from './../../../../services/invoicing/movement.service';
import { GeneralParameterService } from './../../../../services/management/general-parameter.service';

interface GroupMetadata {
  valueWithDiscount: number;
  valueBaseIva: number;
  reteFuenteValue: number;
  reteIcaValue: number;
  conceptName: string;
}

@Component({
  selector: 'app-preview-pre-invoicing',
  templateUrl: './preview-pre-invoicing.component.html',
  styleUrls: ['./preview-pre-invoicing.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PreviewPreInvoicingComponent implements OnInit {
  @Input() companyId: number | null = 0;
  @Input() editFormat: boolean = false;
  @Input() exportFormat: boolean = false;
  @Input() exporterDetailsPreview: any;
  @Input() focusText: boolean = false;
  @Input() formatDetail: FormatDetailModel = new FormatDetailModel();
  @Input() formatModel: FormatModel = new FormatModel();
  @Input() isGeneralFormat: boolean = true;
  @Input() preinvoicingPrintModel: PreinvoicingPrintModel[] = [];
  @Input() filtersPreview: any[] = [];
  @Input() changeOrder: number = PreviewOrderByEnums.clienteCentroCostos;
  @Output() emitFormatDetail = new EventEmitter<FormatDetailModel>();
  @Output() finishLoadingPrint = new EventEmitter<boolean>();

  columns: { field: string; header: string; }[] = [];
  formatType: number = 1;
  groupDataMap = signal<Record<string, GroupMetadata>>({});
  idMap: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: string | null; } } = {};
  idMapGeneral: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: string | null; } } = {
    'index': { id: 'index', type: 'number', showTotal: false, printFormat: null },
    'articleCodeName': { id: 'articulo', type: 'text', showTotal: false, printFormat: null },
    'familyCode': { id: 'familia', type: 'text', showTotal: false, printFormat: null },
    'groupCode': { id: 'grupo', type: 'text', showTotal: false, printFormat: null },
    'subgroupCode': { id: 'subgrupo', type: 'text', showTotal: false, printFormat: null },
    'inventoryUnitCode': { id: 'unidad-medida', type: 'text', showTotal: false, printFormat: null },
    'document': { id: 'documento', type: 'text', showTotal: false, printFormat: null },
    'dateInitial': { id: 'fecha-inicial', type: 'date', showTotal: false, printFormat: null },
    'dateFinal': { id: 'fecha-final', type: 'date', showTotal: false, printFormat: null },
    'quantityUnd': { id: 'cantidad', type: 'decimal', showTotal: false, printFormat: null },
    'residueUnd': { id: 'saldo', type: 'decimal', showTotal: false, printFormat: null },
    'totalTime': { id: 'dias', type: 'decimal', showTotal: false, printFormat: null },
    'unitValueWithoutDiscount': { id: 'valor-unit-sd', type: 'decimal', showTotal: false, printFormat: null },
    'totalValueWithoutDiscount': { id: 'total-unit-sd', type: 'decimal', showTotal: false, printFormat: null },
    'discountRate': { id: 'tarifa-descuento', type: 'decimal', showTotal: false, printFormat: null },
    'discountValue': { id: 'valor-descuento', type: 'decimal', showTotal: false, printFormat: null },
    'unitValueWithDiscount': { id: 'valor-unit-cd', type: 'decimal', showTotal: false, printFormat: null },
    'totalValueWithDiscount': { id: 'valor-total-cd', type: 'decimal', showTotal: false, printFormat: null },
  };
  idMapM2: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: string | null; } } = {
    'index': { id: 'index', type: 'number', showTotal: false, printFormat: null },
    'articleCodeName': { id: 'articulo-2', type: 'text', showTotal: false, printFormat: null },
    'familyCode': { id: 'familia-2', type: 'text', showTotal: false, printFormat: null },
    'groupCode': { id: 'grupo-2', type: 'text', showTotal: false, printFormat: null },
    'subgroupCode': { id: 'subgrupo-2', type: 'text', showTotal: false, printFormat: null },
    'document': { id: 'documento-2', type: 'text', showTotal: false, printFormat: null },
    'dateInitial': { id: 'fecha-inicial-2', type: 'date', showTotal: false, printFormat: null },
    'dateFinal': { id: 'fecha-final-2', type: 'date', showTotal: false, printFormat: null },
    'quantityUnd': { id: 'cantidad-unidad', type: 'decimal', showTotal: false, printFormat: null },
    'residueUnd': { id: 'saldo-unidad', type: 'decimal', showTotal: false, printFormat: null },
    'quantity': { id: 'cantidad-m2', type: 'decimal', showTotal: false, printFormat: null },
    'residue': { id: 'saldo-m2', type: 'decimal', showTotal: false, printFormat: null },
    'totalTime': { id: 'dias-2', type: 'decimal', showTotal: false, printFormat: null },
    'discountRate': { id: 'tarifa-descuento-2', type: 'decimal', showTotal: false, printFormat: null },
    'unitValueWithDiscount': { id: 'valor-unit-cd-2', type: 'decimal', showTotal: false, printFormat: null },
    'totalValueWithDiscount': { id: 'valor-total-cd-2', type: 'decimal', showTotal: false, printFormat: null },
  };

  listFormatDetailUpdates: FormatDetailModel[] = [];
  listObservers: Subscription[] = [];
  listRetentionsModel: any[] = [];
  listStore: ItemFilterModel[] = [];
  movementDetails: MovementDetailModel[] = [];
  bottomPreview: number = 0;
  clientId: number | null = null;
  costCenterId: number | null = null;
  costCenterTypeId: number | null = null;
  dateNow: Date = new Date();
  generalParametersId: number[] = [];
  isShift = false;
  leftPreview: number = 0;
  movementId: number = 0;
  mouseDown: boolean = false;
  rightPreview: number = 0;
  rows: PreinvoicingDetailPrintModel[] = [];
  shiftX: number = 0;
  shiftY: number = 0;
  speed = 2;
  topPreview: number = 0;
  visibleLoading: boolean = true;

  element: any;
  elementStyle: any;
  elementsBody: FormatDetailModel[] = [];
  elementsLabel: FormatDetailModel[] = [];
  labelPrintFormatMap: Record<string, string | null> = {};
  formatModelByCompany: FormatModel = new FormatModel();
  id = '';
  logoEnterprise: SafeUrl | null = null;
  newFormatDetail: FormatDetailModel = new FormatDetailModel();
  textBaseIva: string = '';
  userAuthenticated: string = '';
  version: string = ProjectVersion.projectVersion;
  retefuente: boolean = false;
  reteIca: boolean = false;
  reteIva: boolean = false;

  private keydownListener!: (e: KeyboardEvent) => void;
  private mouseupListener!: () => void;
  private mousemoveListener!: (e: MouseEvent) => void;
  private keyupListener!: (e: KeyboardEvent) => void;

  constructor(private enterpriseService: EnterpriseService,
    private formatDetailService: FormatDetailService,
    private generalParameterService: GeneralParameterService,
    private movementService: MovementService,
    private sanitizer: DomSanitizer,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private printPageSizeService: PrintPageSizeService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) { }

  async ngOnInit() {
    if (this.companyId != 0) await this.getGeneralParameter();
    this.getUserAutheticated();
    this.idMap = this.idMapGeneral;
  }

  async ngOnChanges(changes: SimpleChanges) {
    const {
      exportFormat,
      preinvoicingPrintModel,
      formatDetail,
      exporterDetailsPreview,
      formatModel,
      isGeneralFormat,
      changeOrder
    } = changes;

    if (exportFormat && !exportFormat.firstChange) {
      this.updateRangeFormatDetail();
    }

    if (formatModel && formatModel.firstChange) {
      this.formatModel = formatModel.currentValue;
    }
    if (isGeneralFormat) await this.changeFormatType(preinvoicingPrintModel == undefined);

    if ((preinvoicingPrintModel && !preinvoicingPrintModel.firstChange)) {
      this.visibleLoading = true;
      if (this.preinvoicingPrintModel.length) {
        await Promise.all([
          this.configureFormatByDocument(),
        ]);
      }
      this.visibleLoading = false;

    }
    if (changeOrder) {
      await this.changeOrderBy(changeOrder.currentValue);
    }

    if (formatDetail && !formatDetail.firstChange) this.changeFormatDetail();
    if (exporterDetailsPreview?.previousValue !== undefined) this.exportPreinvoices();
  }

  ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    this.printPageSizeService.removePageSizeStyle();

    // Remover event listeners globales
    if (this.keydownListener) document.removeEventListener('keydown', this.keydownListener);
    if (this.mouseupListener) document.removeEventListener('mouseup', this.mouseupListener, true);
    if (this.mousemoveListener) document.removeEventListener('mousemove', this.mousemoveListener, true);
    if (this.keyupListener) document.removeEventListener('keyup', this.keyupListener);
  }

  //#region Configuration Format 

  trackByMovementId(index: number, item: PreinvoicingPrintModel): number {
    return item.movementId;
  }

  trackByColumnField(index: number, item: { field: string; header: string }): string {
    return item.field;
  }

  buildLabelPrintFormatMap(): void {
    this.labelPrintFormatMap = (this.elementsLabel || []).reduce((acc, item) => {
      acc[item.name] = item.printFormat ?? null;
      return acc;
    }, {} as Record<string, string | null>);
  }

  //#endregion Drag and Drop

  ngAfterViewInit() {
    if (this.editFormat) {
      this.keydownListener = (e: KeyboardEvent) => {
        const target = e.target as HTMLElement;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.tagName === 'SELECT' ||
            target.isContentEditable)
        ) {
          return;
        }
        // 2. Si no hay ningún elemento seleccionado para mover, no bloquear
        if (!this.element) {
          return;
        }

        // Deshabilita desplazamiento del scroll con la tecla espacio y flechas
        if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
          this.blockScrollArrows(e);
        }

        if (e.which == 16) this.isShift = true;
        //Mover element con flechas
        if (!this.isShift) {
          switch (e.key) {
            case 'ArrowLeft': { this.moveLeft(); break; }
            case 'ArrowRight': { this.moveRight(); break; }
            case 'ArrowUp': { this.moveUp(); break; }
            case 'ArrowDown': { this.moveDown(); break; }
          }
        }

        //Modificar element tamaño de objeto
        if (this.isShift) {
          switch (e.which) {
            case 37: { this.decreaseWidth(); break; }
            case 38: { this.decreaseHeight(); break; }
            case 39: { this.increaseWidth(); break; }
            case 40: { this.increaseHeight(); break; }
          }
        }
      };

      this.mouseupListener = () => {
        this.onMouseUp();
      };

      this.mousemoveListener = (e: MouseEvent) => {
        this.onMouseMove(e);
      };

      this.keyupListener = (e: KeyboardEvent) => {
        if (e.which == 16) this.isShift = false;
      };

      // Registrar los listeners en el document
      document.addEventListener('keydown', this.keydownListener);
      document.addEventListener('mouseup', this.mouseupListener, true);
      document.addEventListener('mousemove', this.mousemoveListener, true);
      document.addEventListener('keyup', this.keyupListener);
    }
  }

  blockScrollArrows(e: any) {
    if (!this.focusText) {
      e.preventDefault();
    }
  }

  async changeAlignment(alignment: string) {
    this.element.style.textAlign = alignment;
  }

  changeBold(bold: string) {
    this.element.style.fontWeight = bold;
  }

  changeBorder(border: string) {
    switch (border) {
      case 'noborder': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        break;
      }
      case 'border': {
        this.element.style.border = '1px solid rgb(0, 0, 0)';
        break;
      }
      case 'underline': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        this.element.style.borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }
  }

  changeFormatDetail() {
    if (this.preinvoicingPrintModel.length == 0) return;
    const formatDetailId = this.formatDetail.formatDetailId;
    if (!formatDetailId) return;

    const isBody = this.formatDetail.band === 'body';
    const isLabel = this.formatDetail.type === 'label';

    if (isBody) {
      const element = this.elementsBody.find(
        (x) => x.formatDetailId === formatDetailId
      );
      if (!element) {
        return;
      }

      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;
      element.printFormat = this.formatDetail.printFormat;

      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;
        if (!this.formatDetail.visible) {
          this.columns = this.columns.filter(x => x.field !== element.description);
        } else {
          this.updateElementWidth(
            this.formatDetail.name,
            this.preinvoicingPrintModel[0].movementId!
          );
          this.updateElementStyle(
            this.formatDetail.name,
            this.preinvoicingPrintModel[0].movementId
          );
          this.changeAlignment(this.formatDetail.alignment);
        }
      } else {
        element.bold = this.formatDetail.bold;
        this.preinvoicingPrintModel[0].preinvoicingDetails.forEach((detail) => {
          if (detail.movementDetailId) {
            if (this.element == null) {
              this.element = document.getElementById(`${this.formatDetail.name}-${detail.movementDetailId}`);
            }
            this.updateElementStyle(this.formatDetail.name, detail.movementDetailId);
            this.changeAlignment(this.formatDetail.alignment);
            this.changeBold(this.formatDetail.bold);
          }
        });
      }
      this.elementsBody = this.elementsBody.filter((x) => x.formatDetailId !== formatDetailId);
      this.elementsBody.push(element);
      const fieldName = element.description;
      if (this.isGeneralFormat) {
        if (fieldName && this.idMapGeneral[fieldName]) {
          this.idMapGeneral[fieldName].printFormat = element.printFormat;
        }
      } else {
        if (fieldName && this.idMapM2[fieldName]) {
          this.idMapM2[fieldName].printFormat = element.printFormat;
        }
      }
    } else {
      if (this.formatDetail.name.includes('foot-group')) {
        this.groupingClass(this.formatDetail);
      } else {
        this.updateElementStyle(
          this.formatDetail.name,
          this.preinvoicingPrintModel[0].movementId
        );

        if (!this.formatDetail.visible) {
          if (this.element)
            this.element.setAttribute('hidden', '');
        } else {
          this.applyFormatStyles(this.element);
          this.updateLabelText(formatDetailId, this.formatDetail.text!);
          this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(
            (x) => x.formatDetailId !== formatDetailId
          );
          this.listFormatDetailUpdates.push(this.formatDetail);
        }
      }
      const labelElement = this.elementsLabel.find(x => x.name === this.formatDetail.name);
      if (labelElement) {
        labelElement.printFormat = this.formatDetail.printFormat;
        this.elementsLabel = [...this.elementsLabel];
        this.buildLabelPrintFormatMap();
      }
    }
  }

  private updateElementStyle(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) {
      return;
    }

    this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
  }

  private updateElementWidth(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) {
      return;
    }
    this.element.style.width = `${this.formatDetail.width}%`;
  }

  private applyFormatStyles(element: HTMLElement) {
    element.style.fontSize = `${this.formatDetail.fontSize}px`;
    this.changeAlignment(this.formatDetail.alignment);
    this.changeBold(this.formatDetail.bold);
    this.changeBorder(this.formatDetail.border);

    if (!this.formatDetail.name.includes('foot-')) {
      element.style.position = 'absolute';
      element.style.left = `${this.formatDetail.left}%`;
      element.style.top = `${this.formatDetail.top}%`;
    }

    element.style.height = `${this.formatDetail.height}px`;
    element.style.width = `${this.formatDetail.width}px`;
  }

  private updateLabelText(formatId: number, text: string) {
    const labelElement = this.elementsLabel.find(
      (x) => x.formatDetailId === formatId
    );
    if (labelElement) {
      labelElement.text = text;
    }
  }

  async changeFormatType(emit: boolean) {
    // Válido el tipo de prefactura para definir las columnas de la tabla
    this.idMap = this.isGeneralFormat ? this.idMapGeneral : this.idMapM2;
    this.chargeFormat(this.formatModel).then(() => {
      if (emit) {
        this.dateNow = new Date();
        this.visibleLoading = false;
        this.finishLoadingPrint.emit(true);
      }
    });
  }

  changeOrderBy(order: any) {
    if (order == PreviewOrderByEnums.clienteCentroCostos) {
      this.preinvoicingPrintModel = this.preinvoicingPrintModel.sort(
        function (a, b) {
          //Cliente
          if (a.clientName === b.clientName) {
            //c.costos
            if (a.costCenterName === b.costCenterName) {
              //Tipo
              if (a.costCenterTypeId === b.costCenterTypeId) {
                //Nro
                return a.consecutive > b.consecutive ? 1 : -1;
              }
              return a.costCenterTypeId > b.costCenterTypeId ? 1 : -1;
            }
            return a.costCenterName > b.costCenterName ? 1 : -1;
          }
          return a.clientName > b.clientName ? 1 : -1;

        });
    } else {
      this.preinvoicingPrintModel = this.preinvoicingPrintModel.sort(
        function (a, b) {
          //c.costos
          if (a.costCenterName === b.costCenterName) {
            //Tipo
            if (a.costCenterTypeId === b.costCenterTypeId) {
              //Nro
              return a.consecutive > b.consecutive ? 1 : -1;
            }
            return a.costCenterTypeId > b.costCenterTypeId ? 1 : -1;
          }
          return a.costCenterName > b.costCenterName ? 1 : -1;
        });
    }
  }

  async chargeFormat(formatModel: FormatModel): Promise<boolean> {
    return new Promise((resolved) => {
      this.formatModel = formatModel;
      this.printPageSizeService.setPageSizeStyle(formatModel.paperSizeId);
      this.visibleLoading = true;

      // Extraer y construir columnas SOLO UNA VEZ para todas las facturas
      this.extractFormatDetails(formatModel);
      this.buildDisplayedColumns();

      // Forzar a Angular a procesar la estructura del DOM
      this.cdr.detectChanges();

      this.ngZone.runOutsideAngular(() => {
        // Dar tiempo (100ms) al navegador y PrimeNG para montar el DOM real
        setTimeout(async () => {
          for (let i = 0; i < this.preinvoicingPrintModel.length; i++) {
            const preinvoicing = this.preinvoicingPrintModel[i];

            this.applyHeaderFooterHeights(preinvoicing.movementId, formatModel);
            this.applyFormatDetails(formatModel.formatDetails, preinvoicing);
            this.applyColumnStyles(preinvoicing);
            this.applyParagraphStyles(preinvoicing);

            // Ceder el hilo al navegador cada 2 iteraciones para evitar congelamiento
            if (i % 2 === 0) {
              await new Promise(r => setTimeout(r, 0));
            }
          }

          this.ngZone.run(() => {
            this.visibleLoading = false;
            this.cdr.markForCheck();
            resolved(true);
          });
        }, 100);
      });
    });
  }

  private applyHeaderFooterHeights(
    movementId: number,
    formatModel: FormatModel
  ) {
    const head = document.getElementById(`head-${movementId}`);
    const foot = document.getElementById(`foot-${movementId}`);
    head!.style.height = `${formatModel.head}px`;
    foot!.style.height = `${formatModel.foot}px`;
  }

  private extractFormatDetails(formatModel: FormatModel) {
    this.elementsLabel = formatModel.formatDetails.filter(
      (x) => x.type === 'label'
    );
    this.buildLabelPrintFormatMap();
    this.textBaseIva =
      formatModel.formatDetails.find((x) => x.name === 'foot-group-baseIva')
        ?.text ?? '';
    const copyFormatModel: FormatModel = JSON.parse(
      JSON.stringify(formatModel)
    );

    const generalHeaders = new Set([
      "th-articulo", "th-familia", "th-grupo", "th-subgrupo", "th-documento", "th-fecha-inicial", "th-fecha-final",
      "th-cantidad", "th-saldo", "th-dias", "th-valor-unit-sd",
      "th-total-unit-sd", "th-tarifa-descuento", "th-valor-descuento",
      "th-valor-unit-cd", "th-valor-total-cd"
    ]);

    const m2Headers = new Set([
      "th-articulo-2", "th-familia-2", "th-grupo-2", "th-subgrupo-2", "th-documento-2", "th-fecha-inicial-2",
      "th-cantidad-unidad", "th-saldo-unidad", "th-cantidad-m2",
      "th-saldo-m2", "th-dias-2", "th-tarifa-descuento-2",
      "th-valor-unit-cd-2", "th-valor-total-cd-2"
    ]);

    copyFormatModel.formatDetails.forEach((element) => {
      if (!element) {
        return;
      }

      if (this.isGeneralFormat) {
        if (generalHeaders.has(element.name)) {
          element.visible = !!element.visible;
        } else if (m2Headers.has(element.name)) {
          element.visible = false;
        }
      } else {
        if (m2Headers.has(element.name)) {
          element.visible = !!element.visible;
        } else if (generalHeaders.has(element.name)) {
          element.visible = false;
        }
      }
    });

    this.elementsBody = copyFormatModel.formatDetails
      .filter((x) => x.band === 'body' && x.visible)
      .sort((a, b) => a.orderTable - b.orderTable);

  }

  private buildDisplayedColumns() {
    this.columns = [];
    this.elementsBody.filter((x) => x.type === 'label').forEach((element) => {
      this.columns.push({ field: element.description!, header: element.text! });
      if (this.isGeneralFormat) {
        this.idMapGeneral[element.description!].printFormat = element.printFormat ?? null;
      } else {
        this.idMapM2[element.description!].printFormat = element.printFormat ?? null;
      }
    });
  }

  private async applyFormatDetails(
    elements: FormatDetailModel[],
    preinvoicing: PreinvoicingPrintModel
  ) {
    for (const element of elements) {
      if (element.band === 'body') continue;

      if (element.name.includes('foot-group')) {
        setTimeout(() => {
          this.groupingClass(element);
        }, 0);
      } else {
        this.element = document.getElementById(
          `${element.name}-${preinvoicing.movementId}`
        );
        if (this.element) {
          this.applyElementStyles(element);
        }
      }
    }
  }

  private applyElementStyles(element: FormatDetailModel) {
    if (!element.visible) {
      this.element!.setAttribute('hidden', '');
      return;
    }

    const style = this.element!.style;
    style.fontSize = `${element.fontSize}px`;
    this.changeAlignment(element.alignment);
    this.changeBold(element.bold);
    this.changeBorder(element.border);

    if (element.name.includes('foot-')) {
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    } else {
      style.backgroundColor = 'transparent';
      style.position = 'absolute';
      style.left = `${element.left}%`;
      style.top = `${element.top}%`;
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    }
  }

  private async applyColumnStyles(preinvoicing: PreinvoicingPrintModel) {
    for (const column of this.columns.map(x => x.field)) {
      const element = this.elementsBody.find((x) => x.description === column);
      if (!element) continue;

      this.element = document.getElementById(
        `${element.name}-${preinvoicing.movementId}`

      );
      if (this.element) {
        this.element.style.fontSize = `${element.fontSize}px`;
        this.element.style.width = `${element.width}%`;
        await this.changeAlignment(element.alignment);
      }

    }
  }

  private applyParagraphStyles(preinvoicing: PreinvoicingPrintModel) {
    this.elementsBody
      .filter((x) => x.type === 'p')
      .forEach((element) => {
        preinvoicing.preinvoicingDetails.forEach((detail) => {
          this.element = document.getElementById(
            `${element.name}-${detail.movementDetailId}`
          );
          if (this.element) {
            this.element.style.fontSize = `${element.fontSize}px`;
            this.changeAlignment(element.alignment);
            this.changeBold(element.bold);
          }
        });
      });
  }

  clickTable(event: any) {
    if (!this.editFormat) {
      return;
    }
    const element = document.getElementById(event.target.id);
    if (!element) {
      return;
    }

    const elementStyle = window.getComputedStyle(element);
    const name = event.target.id.substring(0, event.target.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(
      (x) => x.name === name
    );
    const bodyElement = this.elementsBody.find((x) => x.name === name);

    if (!formatDetail || !bodyElement) {
      return;
    }

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.type = formatDetail.type;
    this.newFormatDetail.visible = bodyElement.visible;
    this.newFormatDetail.text = bodyElement.text;
    this.newFormatDetail.orderTable = bodyElement.orderTable;
    this.newFormatDetail.printFormat = bodyElement.printFormat;

    // Ancho
    if (formatDetail.type === 'label') {
      const rawWidth = element.style.width;
      const width = parseFloat(rawWidth.replace('%', '')) || 0;
      this.newFormatDetail.width = parseFloat(width.toFixed(4));
    } else {
      this.newFormatDetail.width = 0;
    }

    // Tamaño de fuente
    const fontSize = parseInt(
      elementStyle.getPropertyValue('font-size').replace('px', '')
    );
    this.newFormatDetail.fontSize = isNaN(fontSize) ? 0 : fontSize;

    // Negrita
    const fontWeight = elementStyle.getPropertyValue('font-weight');
    this.newFormatDetail.bold = fontWeight === '400' ? 'normal' : 'bold';

    // Alineación
    this.newFormatDetail.alignment =
      elementStyle.getPropertyValue('text-align');

    this.emitFormatDetail.emit(this.newFormatDetail);
  }

  private adjustElementSize(property: 'height' | 'width', delta: number) {
    if (this.focusText) {
      return;
    }

    const currentValue = this.elementStyle.getPropertyValue(property);
    const numericValue = parseFloat(currentValue.replace('px', ''));

    const newValue = numericValue + delta;
    this.element.style[property] = `${newValue}px`;
    this.onClick();
  }

  decreaseHeight() {
    this.adjustElementSize('height', -this.speed);
  }

  increaseHeight() {
    this.adjustElementSize('height', this.speed);
  }

  decreaseWidth() {
    this.adjustElementSize('width', -this.speed);
  }

  increaseWidth() {
    this.adjustElementSize('width', this.speed);
  }

  onColumnReorder() {
    this.columns.forEach((col, index) => {
      this.elementsBody.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  async configureFormatByDocument() {
    const enterpriseLogo = this.preinvoicingPrintModel[0].enterpriseLogo;
    if (enterpriseLogo == null) {
      await this.getLogoDefault();
    } else {
      if (this.logoEnterprise === null) await this.getLogo(enterpriseLogo);
    }

    const movementIds = this.preinvoicingPrintModel.map((p) => p.movementId);
    this.listRetentionsModel = await firstValueFrom(this.movementService.getRetentionsByMovements(movementIds));

    try {
      const promises = this.preinvoicingPrintModel.flatMap(preinvoicing => this.processInvoicing(preinvoicing));

      await Promise.all(promises);
      await this.chargeFormat(this.formatModel);
      this.dateNow = new Date();
      this.visibleLoading = false;
      this.cdr.markForCheck();
      this.finishLoadingPrint.emit(true)
    } catch (error) {
      console.error("Error en la configuración de factura:", error);
    }
  }

  private processInvoicing(preinvoicing: PreinvoicingPrintModel): Promise<void>[] {
    const promises: Promise<void>[] = [];

    // Pre-calcular nombre completo del cliente
    (preinvoicing as any).clientDocumentName1 = preinvoicing.clientDocumentName2 == null
      ? preinvoicing.clientDocumentName1
      : `${preinvoicing.clientDocumentName1}-${preinvoicing.clientDocumentName2}`;

    //Ordenar y Re-indexar detalles por concepto
    preinvoicing.preinvoicingDetails
      .sort((a, b) => a.conceptInvoicingId - b.conceptInvoicingId)
      .forEach((detail, index) => (detail.index = index + 1));

    // Procesar Grupos si aplica
    if (this.formatModel.group) {
      const conceptPromises = this.getGroupPromises(preinvoicing);
      promises.push(...conceptPromises);
    }

    return promises;
  }

  private getGroupPromises(preinvoicing: PreinvoicingPrintModel): Promise<void>[] {
    const uniqueConceptIds = [...new Set(preinvoicing.preinvoicingDetails.map(d => d.conceptInvoicingId))];

    const partialResult: Record<string, GroupMetadata> = {};
    const promises = uniqueConceptIds.map(async (conceptId) => {
      const groupItems = preinvoicing.preinvoicingDetails.filter(d => d.conceptInvoicingId === conceptId);
      const firstItem = groupItems[0];
      const totalValueGroup = groupItems.reduce((sum, item) => sum + (item.totalValueWithDiscount || 0), 0);

      //Busco las retenciones
      const retention = this.listRetentionsModel?.find((r: any) => r.movementId === preinvoicing.movementId)
        ?.retentions?.find((r: any) => r.conceptInvoicingId === conceptId);
      const {
        baseIva = 0,
        reteFuenteValue = 0,
        reteIcaValue = 0
      } = retention ?? {};

      partialResult[`${preinvoicing.movementId}_${conceptId}`] = {
        valueWithDiscount: totalValueGroup,
        valueBaseIva: baseIva,
        reteFuenteValue,
        reteIcaValue,
        conceptName: firstItem.codeNameConceptInvoicing
      };
    });

    Promise.all(promises).then(() => {
      this.groupDataMap.update(current => ({ ...current, ...partialResult }));
    });

    return promises;

  }

  async exportPreinvoices() {
    const details = this.preinvoicingPrintModel?.[0]?.preinvoicingDetails;
    if (!details || details.length === 0) {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
      return;
    }
    try {
      const filters: ColumnResponseModel[] = [];
      if (this.filtersPreview.length > 0) {
        const clientId = this.filtersPreview.find(x => x.label == 'clientId').value ?? 0;
        if (clientId > 0) {
          filters.push({
            ...new ColumnResponseModel(), propertyName: 'clientId', valueFilter: clientId.toString(), isFilter: true
          });
        }
        const costCenterId = this.filtersPreview.find(x => x.label == 'costCenterId').value ?? 0;
        if (costCenterId > 0) {
          filters.push({
            ...new ColumnResponseModel(), propertyName: 'costCenterId', valueFilter: costCenterId.toString(), isFilter: true
          });
        }
        const costCenterTypeRaw = this.filtersPreview.find(x => x.label == 'costCenterTypeId').value;
        const costCenterTypeId = costCenterTypeRaw?.id ?? costCenterTypeRaw ?? 0;
        if (costCenterTypeId > 0) {
          filters.push({
            ...new ColumnResponseModel(), propertyName: 'costCenterTypeId', valueFilter: costCenterTypeId.toString(), isFilter: true
          });
        }
      }
      const invoicingCutoffId = this.preinvoicingPrintModel[0]?.invoicingCutoffId ?? 0;
      const blob = await firstValueFrom(this.movementService.exportPreinvoices(filters, invoicingCutoffId));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'VistaPreviaDetalles.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar:', error);
    }
  }

  async getGeneralParameter() {
    const response = await firstValueFrom(
      this.generalParameterService.getGeneralParametersByCompany(
        this.companyId!
      )
    );
    this.generalParametersId = response.map((o) => o.generalParameterId);
    if (this.generalParametersId.length) {
      const ids = new Set(this.generalParametersId);
      this.reteIva = ids.has(GeneralParameterEnums.reteIvaEnFactura);
      this.retefuente = ids.has(GeneralParameterEnums.retefuenteEnFactura);
      this.reteIca = ids.has(GeneralParameterEnums.reteIcaEnFactura);
    }
  }

  async getLogo(enterpriseLogo: string) {
    let blob: Blob | null = null;
    try {
      blob = await firstValueFrom(
        this.enterpriseService.getEnterpriseLogoAsync(enterpriseLogo)
      );
      if (blob) {
        const objectURL = URL.createObjectURL(blob);
        this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      }
    } catch (error) {
      console.error('Error al obtener el logo de la empresa.', error);
    }
  }

  async getLogoDefault() {
    const logoPath = 'assets/images/icons/logo-empty.png';
    this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(logoPath);
  }

  async groupingClass(element: FormatDetailModel) {
    const classMap: { [key: string]: string } = {
      'foot-group-concept': '.group-concept',
      'foot-group-baseIva': '.group-baseIva',
      'foot-group-retefuente': '.group-retefuente',
      'foot-group-reteica': '.group-reteica',
    };

    const selector = classMap[element.name];
    if (selector) {
      const classEdit = document.querySelectorAll(selector);
      await this.setGroupingStyles(element, classEdit);
    }
  }

  getUserAutheticated() {
    return new Promise((resolve) => {
      const sub = this.userAuthenticatedService.userObservable.subscribe((value) => {
        this.userAuthenticated = value.userName;
        this.cdr.markForCheck();
      });
      this.listObservers.push(sub);
      resolve(true);
    });
  }

  isGroup(index: any, item: any): boolean {
    return item.level;
  }

  private moveElement(
    direction: 'top' | 'left',
    delta: number,
    previewLimit: number,
    isVertical: boolean
  ) {
    if (this.focusText || !this.elementStyle) {
      return;
    }

    const currentValue = this.elementStyle.getPropertyValue(direction);
    let position = parseFloat(currentValue.replace('px', ''));

    position += delta;

    const sizeProp = isVertical ? 'height' : 'width';
    const size = parseFloat(
      this.elementStyle.getPropertyValue(sizeProp).replace('px', '')
    );

    // Restringir dentro del contenedor
    if (position < 0) position = 0;
    if (position + size > previewLimit) position = previewLimit - size;

    const percentage = ((position / previewLimit) * 100).toFixed(4);
    this.element.style[direction] = `${percentage}%`;

    this.onClick();
  }

  moveUp() {
    this.moveElement('top', -this.speed, this.bottomPreview, true);
  }

  moveDown() {
    this.moveElement('top', this.speed, this.bottomPreview, true);
  }

  moveLeft() {
    this.moveElement('left', -this.speed, this.rightPreview, false);
  }

  moveRight() {
    this.moveElement('left', this.speed, this.rightPreview, false);
  }

  onClick() {
    if (!this.editFormat) {
      return;
    }


    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find((x) => x.name === name);
    if (!formatDetail) { return; }

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.text = formatDetail.text;
    this.newFormatDetail.visible = true;
    this.newFormatDetail.printFormat = formatDetail.printFormat;

    this.newFormatDetail.fontSize = this.getStylePxValue('font-size');
    this.newFormatDetail.bold =
      this.elementStyle.getPropertyValue('font-weight') === '400'
        ? 'normal'
        : 'bold';
    this.newFormatDetail.alignment =
      this.elementStyle.getPropertyValue('text-align');
    this.newFormatDetail.border = this.getBorderStyle();

    if (!name.includes('foot-')) {
      this.newFormatDetail.left = parseFloat(
        ((this.getStylePxValue('left') / this.rightPreview) * 100).toFixed(4)
      );
      this.newFormatDetail.top = parseFloat(
        ((this.getStylePxValue('top') / this.bottomPreview) * 100).toFixed(4)
      );
    }

    this.newFormatDetail.width = parseFloat(
      this.getStylePxValue('width').toFixed(4)
    );
    this.newFormatDetail.height = parseFloat(
      this.getStylePxValue('height').toFixed(4)
    );

    this.emitFormatDetail.emit(this.newFormatDetail);
    this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(
      (x) => x.formatDetailId !== this.newFormatDetail.formatDetailId
    );
    this.listFormatDetailUpdates.push(this.newFormatDetail);
  }

  private getStylePxValue(property: string): number {
    const value = this.elementStyle.getPropertyValue(property);
    return parseFloat(value.replace('px', '')) || 0;
  }

  private getBorderStyle(): string {
    if (!this.elementStyle) return 'noborder';

    const sides = ['top', 'right', 'bottom', 'left'] as const;

    const hasBorder = (side: (typeof sides)[number]) => {
      const width = this.elementStyle.getPropertyValue(`border-${side}-width`);
      const style = this.elementStyle.getPropertyValue(`border-${side}-style`);
      return style !== 'none' && width !== '0px';
    };

    const borderStates = sides.map((side) => hasBorder(side));
    const [top, right, bottom, left] = borderStates;

    if (top || right || left) {
      return 'border';
    } else if (bottom) {
      return 'underline';
    } else {
      return 'noborder';
    }
  }

  onDragStart(event: any) {
    if (event?.target && ((event.target as HTMLElement).tagName === 'TH' || (event.target as HTMLElement).closest('th'))) {
      return true;
    }
    event?.preventDefault();
    return false;
  }

  onMouseDown(event: any) {
    if (!this.editFormat) {
      return;
    }

    const targetId = event.target.id;
    if (!targetId || targetId.startsWith('head-') || targetId.startsWith('preview-preInvoicing-') || targetId.startsWith('th-') || targetId.startsWith('td-')
      || targetId.startsWith('container-totals') || targetId === '') return;

    if (this.element) this.element.style.backgroundColor = 'transparent';

    this.mouseDown = true;
    this.id = targetId;
    this.element = document.getElementById(this.id);
    if (!this.element) {
      return;
    }

    this.elementStyle = window.getComputedStyle(this.element);
    this.element.style.backgroundColor = '#0d6efd6e';

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(
      (x) => x.name === name
    );
    if (!formatDetail) {
      return;
    }

    const relativeElement = document.getElementById(
      `${formatDetail.band}-${this.preinvoicingPrintModel[0].movementId}`
    );
    if (!relativeElement) {
      return;
    }

    const relativeStyle = window.getComputedStyle(relativeElement);

    this.leftPreview = Math.round(
      relativeElement.offsetLeft - relativeElement.scrollLeft
    );
    this.topPreview = Math.round(
      relativeElement.offsetTop - relativeElement.scrollTop
    );
    this.rightPreview = parseInt(relativeStyle.width.replace('px', ''));
    this.bottomPreview = parseInt(relativeStyle.height.replace('px', ''));

    if (!this.id.includes('foot-')) {
      this.element.style.cursor = 'move';

      const leftPX = event.pageX - this.leftPreview;
      const topPX = event.pageY - this.topPreview;

      this.shiftX = leftPX - this.getStylePx('left');
      this.shiftY = topPX - this.getStylePx('top');
    }

    this.onClick();
  }

  onMouseMove(event: any) {
    if (!this.mouseDown || this.id.includes('foot-')) {
      return;
    }

    this.element.style.position = 'absolute';

    const leftPx = Math.max(0, event.pageX - this.leftPreview - this.shiftX);
    const widthPx = this.getStylePx('width');
    const finalLeft = Math.min(leftPx, this.rightPreview - widthPx);

    const topPx = Math.max(0, event.pageY - this.topPreview - this.shiftY);
    const heightPx = this.getStylePx('height');
    const finalTop = Math.min(topPx, this.bottomPreview - heightPx);

    this.updateElementPosition(finalLeft, finalTop);
    this.onClick();
  }

  private getStylePx(property: string): number {
    return (
      parseFloat(
        this.elementStyle.getPropertyValue(property).replace('px', '')
      ) || 0
    );
  }

  private updateElementPosition(leftPx: number, topPx: number) {
    const leftPercentage = ((leftPx / this.rightPreview) * 100).toFixed(4);
    const topPercentage = ((topPx / this.bottomPreview) * 100).toFixed(4);

    this.element.style.left = `${leftPercentage}%`;
    this.element.style.top = `${topPercentage}%`;
  }

  onMouseUp() {
    this.mouseDown = false;
  }

  async setGroupingStyles(element: FormatDetailModel, classEdit: any) {
    let border: string, borderBottom: string;
    switch (element.border) {
      case 'noborder': {
        border = '0px none rgb(0, 0, 0)';
        borderBottom = '';
        break;
      }
      case 'border': {
        border = '1px solid rgb(0, 0, 0)';
        borderBottom = '';
        break;
      }
      case 'underline': {
        border = '0px none rgb(0, 0, 0)';
        borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }

    classEdit.forEach((el: HTMLElement) => {
      el.style.backgroundColor = 'transparent';
      el.style.fontSize = `${element.fontSize}px`;
      el.style.textAlign = element.alignment;
      el.style.fontWeight = element.bold;
      el.style.border = border;
      el.style.borderBottom = borderBottom;
      el.style.height = `${element.height}px`;
      el.style.width = `${element.width}px`;
    });
  }

  async updateRangeFormatDetail() {
    this.elementsBody.forEach((element) => {
      this.listFormatDetailUpdates.push(element);
    });
    const response = await firstValueFrom(
      this.formatDetailService.updateRangeFormatDetail(
        this.listFormatDetailUpdates
      )
    );
    this.chargeFormat(response);
  }
}
